import { Box } from '@altermaind/web/ui';
import { ClaimsComponent } from '@/_shared/components/Claims';
import { GoToPublicsDocs } from '@/_shared/components/GoToPublicsDocs';
import { Roles } from '@/_shared/constants/roles';
import { HomepageEmployee } from '../components';
import { HomepageManager } from '../components/HomepageManager/HomepageManager';

export const DashboardLearning = () => {
  return (
    <Box>
      <Box display='flex' justifyContent='flex-end'>
        <GoToPublicsDocs mb='xxxxs' />
      </Box>
      <ClaimsComponent roles={[Roles.Employee]}>
        <HomepageEmployee />
      </ClaimsComponent>
      <ClaimsComponent roles={[Roles.Manager]}>
        <HomepageManager />
      </ClaimsComponent>
    </Box>
  );
};
